import { CurrencyValue } from '../model'
import { BigNumber } from '@ethersproject/bignumber'
import { Settings } from '../providers'
import { GAS_LIMIT_SAFETY_OFFSET } from '../constants'

export function getAffordableMaxValueFor(executionGasLimit: number, orderGasLimit: number) {
  return function (balance: CurrencyValue, delayGasPrice: BigNumber, maxGasFee: BigNumber, settings: Settings) {
    const safeGasLimit = executionGasLimit + settings.gasLimitOverpay
    const safeGasPrice = delayGasPrice.mul(settings.gasPriceMultiplier).div(1000)
    const orderExecutionCost = safeGasPrice.mul(safeGasLimit)
    const sendingTxMaxCost = maxGasFee.mul(orderGasLimit + GAS_LIMIT_SAFETY_OFFSET)
    return balance.value.sub(orderExecutionCost).sub(sendingTxMaxCost)
  }
}
